import { useNavigate } from 'react-router-dom';
import { Building2, LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { BillerBayLogo } from '@/components/ui/BillerBayLogo';
import { useLogout } from '@/api/auth';

export function OrgPickerPage() {
  const { organizations, setActiveOrg, logout } = useAuth();
  const navigate = useNavigate();
  const logoutMut = useLogout();

  const handleSelect = (orgId: string) => {
    setActiveOrg(orgId);
    navigate('/');
  };

  const handleLogout = async () => {
    try {
      await logoutMut.mutateAsync();
    } catch {
      /* ignore */
    }
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#12122C] flex flex-col items-center justify-center px-4">
      <div className="mb-8">
        <BillerBayLogo variant="light" height={32} />
      </div>

      <div className="w-full max-w-md">
        <div className="bg-white dark:bg-[#1A1A30] rounded-xl shadow-2xl overflow-hidden">
          <div className="px-6 py-5 border-b border-[#E3E3F1] dark:border-[#2A2A4A]">
            <h1 className="text-lg font-semibold text-[#12122C] dark:text-white">
              Select an organization
            </h1>
            <p className="text-sm text-[#676687] dark:text-[#8888AA] mt-0.5">
              You belong to multiple organizations. Choose one to continue.
            </p>
          </div>

          <ul className="divide-y divide-[#E3E3F1] dark:divide-[#2A2A4A]">
            {organizations.map((org) => (
              <li key={org.id}>
                <button
                  type="button"
                  onClick={() => handleSelect(org.id)}
                  className="w-full flex items-center gap-3 px-6 py-4 text-left hover:bg-[#F2F2F8] dark:hover:bg-[#22223A] transition-colors group"
                >
                  <span className="w-10 h-10 rounded-lg bg-[#EFF0FF] dark:bg-[#1E2040] flex items-center justify-center shrink-0">
                    <Building2 size={20} className="text-[#0410BD] dark:text-[#818CF8]" />
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm font-semibold text-[#12122C] dark:text-white truncate group-hover:text-[#0410BD] dark:group-hover:text-[#818CF8] transition-colors">
                      {org.name}
                    </span>
                  </span>
                  <span className="text-[#BABACE] dark:text-[#4A4A6A] group-hover:text-[#0410BD] dark:group-hover:text-[#818CF8] transition-colors text-xs font-medium">
                    Select →
                  </span>
                </button>
              </li>
            ))}
          </ul>

          <div className="px-6 py-4 border-t border-[#E3E3F1] dark:border-[#2A2A4A]">
            <button
              type="button"
              onClick={handleLogout}
              className="inline-flex items-center gap-2 text-sm text-[#676687] dark:text-[#8888AA] hover:text-[#12122C] dark:hover:text-white transition-colors"
            >
              <LogOut size={14} />
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
